import { useQuery } from "@tanstack/react-query";
import { getBanners } from "../../services/apiBanners";

export function useBanners() {
  const {
    isLoading,
    data: banners,
    error,
  } = useQuery({
    queryKey: ["banners"],
    queryFn: getBanners,
    refetchInterval: 15000, // 15 seconds
    retry: 5,
  });

  return { isLoading, banners, error };
}
